import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function OwnerAuditPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Auditoría</h1>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Registros de auditoría</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Métricas globales y logs. Próximamente.</p>
        </CardContent>
      </Card>
    </div>
  );
}
